var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInitiativesGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 621.12 353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-21,.cls-22,.cls-27,.cls-29,.cls-31,.cls-32,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{opacity:0.5;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-21,.cls-22,.cls-24,.cls-25,.cls-27,.cls-29,.cls-31,.cls-32,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#f5f5f5;}.cls-4{fill:url(#linear-gradient-2);}.cls-20,.cls-5{fill:#6c63ff;}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-13);}.cls-17{fill:url(#linear-gradient-14);}.cls-18{fill:url(#linear-gradient-15);}.cls-19{fill:url(#linear-gradient-16);}.cls-21{fill:#3ad29f;}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:#e6e6e6;}.cls-24{opacity:0.03;}.cls-25{opacity:0.05;}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32,.cls-35{fill:none;stroke-miterlimit:10;stroke-width:3px;}.cls-32{stroke:#3ad29f;stroke-dasharray:12;}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:#333;}.cls-35{stroke:#333;}.cls-36{fill:url(#linear-gradient-25);}.cls-37{fill:url(#linear-gradient-26);}.cls-38{fill:url(#linear-gradient-27);}.cls-39{fill:#22b573;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 429.86,
    y1: 15480.38,
    x2: 429.86,
    y2: 15712.62,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 15773)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 270.48,
    y1: 15657.63,
    x2: 270.48,
    y2: 15680.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 305.07,
    y1: 15627.15,
    x2: 305.07,
    y2: 15649.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 339.65,
    y1: 15596.23,
    x2: 339.65,
    y2: 15618.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 374.24,
    y1: 15565.76,
    x2: 374.24,
    y2: 15588.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 408.83,
    y1: 15535.28,
    x2: 408.83,
    y2: 15557.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 443.42,
    y1: 15504.81,
    x2: 443.42,
    y2: 15527.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 497.28,
    y1: 15569.14,
    x2: 497.28,
    y2: 15589.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 538.4,
    y1: 15569.14,
    x2: 538.4,
    y2: 15589.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 579.52,
    y1: 15569.14,
    x2: 579.52,
    y2: 15589.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 497.28,
    y1: 15537.58,
    x2: 497.28,
    y2: 15558.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 538.4,
    y1: 15537.58,
    x2: 538.4,
    y2: 15558.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 579.52,
    y1: 15537.58,
    x2: 579.52,
    y2: 15558.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 497.28,
    y1: 15506.03,
    x2: 497.28,
    y2: 15526.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 538.4,
    y1: 15506.03,
    x2: 538.4,
    y2: 15526.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 579.52,
    y1: 15506.03,
    x2: 579.52,
    y2: 15526.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 438.46,
    y1: 15399.6,
    x2: 596.87,
    y2: 15399.6,
    gradientTransform: "matrix(1, 0, 0, -1, -173.22, 15715)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 549.4,
    y1: 15725.36,
    x2: 549.4,
    y2: 15756.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 722.62,
    y1: 15681.07,
    x2: 722.62,
    y2: 15685.21,
    gradientTransform: "matrix(1, 0, 0, -1, -173.22, 15715)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 517.36,
    y1: 15725.36,
    x2: 517.36,
    y2: 15756.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 690.58,
    y1: 15681.07,
    x2: 690.58,
    y2: 15685.21,
    gradientTransform: "matrix(1, 0, 0, -1, -173.22, 15715)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 530.75,
    y1: 15726.79,
    x2: 530.75,
    y2: 15758.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 703.97,
    y1: 15682.5,
    x2: 703.97,
    y2: 15686.64,
    gradientTransform: "matrix(1, 0, 0, -1, -173.22, 15715)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 515.32,
    y1: 15652.95,
    x2: 515.32,
    y2: 15688.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 561.48,
    y1: 15652.95,
    x2: 561.48,
    y2: 15688.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 515.32,
    y1: 15611.72,
    x2: 515.32,
    y2: 15646.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 561.48,
    y1: 15611.72,
    x2: 561.48,
    y2: 15646.8,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1Asset 44") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.73,
    y: 100.71,
    width: 120,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 133.73,
    y: 131.31,
    width: 121,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.73,
    y: 161.92,
    width: 42,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 159.73,
    y: 192.52,
    width: 95,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.73,
    y: 223.12,
    width: 143,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.73,
    y: 253.72,
    width: 127,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 238.61,
    y: 60.38,
    width: 382.51,
    height: 232.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 241.95,
    y: 64.37,
    width: 375.82,
    height: 224.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.17,
    y: 100.71,
    width: 195.56,
    height: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 270.48,
    cy: 104.06,
    r: 11.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 270.48,
    cy: 104.06,
    r: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.17,
    y: 131.31,
    width: 195.56,
    height: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 305.07,
    cy: 134.54,
    r: 11.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 304.87,
    cy: 134.66,
    r: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.17,
    y: 161.92,
    width: 195.56,
    height: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 339.65,
    cy: 165.46,
    r: 11.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 339.43,
    cy: 165.27,
    r: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.17,
    y: 192.52,
    width: 195.56,
    height: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 374.24,
    cy: 195.93,
    r: 11.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 374.15,
    cy: 195.86,
    r: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.17,
    y: 223.12,
    width: 195.56,
    height: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 408.83,
    cy: 226.41,
    r: 11.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 408.63,
    cy: 226.47,
    r: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.17,
    y: 253.72,
    width: 195.56,
    height: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 443.42,
    cy: 256.88,
    r: 11.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 443.52,
    cy: 257.07,
    r: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 481.98,
    y: 183.09,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 523.1,
    y: 183.09,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 564.22,
    y: 183.09,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 481.98,
    y: 214.65,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 523.1,
    y: 214.65,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 564.22,
    y: 214.65,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 481.98,
    y: 246.2,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 523.1,
    y: 246.2,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 564.22,
    y: 246.2,
    width: 30.6,
    height: 20.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 483.89,
    y: 184.39,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 525.01,
    y: 184.39,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 566.13,
    y: 184.39,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 483.89,
    y: 215.95,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 525.01,
    y: 215.95,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 566.13,
    y: 215.95,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 483.89,
    y: 247.5,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 525.01,
    y: 247.5,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 566.13,
    y: 247.5,
    width: 26.78,
    height: 18.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M406,307.27c-2.69,0-4.68.45-6.1,2.91H342.21V304c0-1.61-2.06-1-3.42-1h-1.12c-1.34,0-2.46-.61-2.46,1v1.38H270.45c-3.35,0-4.68,2.94-5.14,6.76,0-.1,0-.19,0-.29,0,.27,0,.55,0,.83v4.18c0,4.36,1.54,7.88,5.22,7.88H335.2v2.1c0,1.61,1.1,1,2.46,1h1.12c1.34,0,3.42.6,3.42-1v-6.13h58a9,9,0,0,0,.87,1.09c2.48,1.26,2.52,1.54,4.79,1.54l17.77-.72V308.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.19,
    y: 311.1,
    width: 88.93,
    height: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M399.2,315.4h0a7.62,7.62,0,0,0,1.34,4.3h1.12v-8.6h-1.12A7.62,7.62,0,0,0,399.2,315.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M423.17,321.25,407.31,323a7.62,7.62,0,0,1-7.62-7.62h0a7.62,7.62,0,0,1,7.62-7.62h0l15.86,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M400.53,316.84H312.7v2.39h87.84a7.62,7.62,0,0,0,6.31,3.33l15.86-1.75v-2.39l-15.86,1.76A7.62,7.62,0,0,1,400.53,316.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M272.22,307.15h64.44V323H272.22a6,6,0,0,1-6-6v-3.77A6,6,0,0,1,272.22,307.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 335.48,
    y: 303.62,
    width: 5.87,
    height: 23.49,
    rx: 2.24,
    ry: 2.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 334.31,
    y: 307.15,
    width: 1.17,
    height: 15.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 276.17,
    y: 310.08,
    width: 54.02,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 276.17,
    y: 314.19,
    width: 54.02,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 276.17,
    y: 318.31,
    width: 54.02,
    height: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M339,322.33h-1.09a2.39,2.39,0,0,1-2.39-2.39h0v-1.72H272.64a6.45,6.45,0,0,1-6.42-5.78,6.54,6.54,0,0,0,0,.68v2.94a6.45,6.45,0,0,0,6.45,6.45h62.84v1.72a2.39,2.39,0,0,0,2.39,2.39H339a2.39,2.39,0,0,0,2.39-2.39h0v-4.3A2.39,2.39,0,0,1,339,322.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "549.4 16.08 537.07 23.2 537.07 26.28 537.07 37.44 537.07 40.52 549.4 47.64 561.73 40.52 561.73 37.44 561.73 26.28 561.73 23.2 549.4 16.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M549.4,33.93a3.62,3.62,0,0,1-3.27-2.07,3.62,3.62,0,0,1,6.54,0A3.62,3.62,0,0,1,549.4,33.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M549.4,20l-11.48,6.62V39.92l11.48,6.62,11.48-6.62V26.67Zm0,16.58a3.35,3.35,0,1,1,3.35-3.35h0a3.35,3.35,0,0,1-3.33,3.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.4,17.18,537.92,23.8V37.05l11.48,6.62,11.48-6.62V23.8Zm0,16.58a3.35,3.35,0,1,1,3.35-3.35,3.35,3.35,0,0,1-3.35,3.35h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "517.37 16.08 505.03 23.2 505.03 26.28 505.03 37.44 505.03 40.52 517.37 47.64 529.69 40.52 529.69 37.44 529.69 26.28 529.69 23.2 517.37 16.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M517.36,33.93a3.62,3.62,0,0,1-3.27-2.07,3.62,3.62,0,0,1,6.54,0A3.62,3.62,0,0,1,517.36,33.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M517.36,20l-11.48,6.62V39.92l11.48,6.62,11.48-6.62V26.67Zm0,16.58a3.35,3.35,0,1,1,3.35-3.35h0a3.35,3.35,0,0,1-3.33,3.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M517.36,17.18,505.89,23.8V37.05l11.48,6.62,11.48-6.62V23.8Zm0,16.58a3.35,3.35,0,1,1,3.35-3.35h0a3.35,3.35,0,0,1-3.33,3.37h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "530.75 14.65 518.42 21.77 518.42 24.85 518.42 36.01 518.42 39.09 530.75 46.21 543.08 39.09 543.08 36.01 543.08 24.85 543.08 21.77 530.75 14.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M530.75,32.5a3.62,3.62,0,0,1-3.27-2.07,3.62,3.62,0,0,1,6.54,0A3.62,3.62,0,0,1,530.75,32.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M530.75,18.61l-11.48,6.62V38.47l11.48,6.62,11.48-6.62V25.24Zm0,16.58a3.35,3.35,0,1,1,3.35-3.35h0a3.35,3.35,0,0,1-3.33,3.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M530.75,15.74l-11.48,6.62V35.62l11.48,6.62,11.48-6.62V22.37Zm0,16.58A3.35,3.35,0,1,1,534.1,29h0a3.35,3.35,0,0,1-3.33,3.37h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "310.81 46.69 310.81 8.43 469.55 8.43"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 485.09,
    cy: 8.2,
    r: 6.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "602.95 306.31 602.95 344.57 444.2 344.57"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 428.67,
    cy: 344.8,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 515.32,
    cy: 102.51,
    r: 17.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 515.32,
    cy: 102.51,
    r: 16.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 515.32,
    cy: 102.51,
    r: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 515.32,
    y1: 102.51,
    x2: 525.18,
    y2: 92.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M518.17,102.07a16.42,16.42,0,0,0,7.37,13.71A16.44,16.44,0,0,0,524.62,89,16.41,16.41,0,0,0,518.17,102.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 561.48,
    cy: 102.51,
    r: 17.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 561.48,
    cy: 102.51,
    r: 16.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 561.48,
    cy: 102.51,
    r: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 561.48,
    y1: 102.51,
    x2: 571.34,
    y2: 92.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M564.33,102.07a16.42,16.42,0,0,0,7.37,13.71A16.44,16.44,0,0,0,570.78,89,16.41,16.41,0,0,0,564.33,102.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 515.32,
    cy: 143.74,
    r: 17.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 515.32,
    cy: 143.74,
    r: 16.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 515.32,
    cy: 143.74,
    r: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 515.32,
    y1: 143.74,
    x2: 504.83,
    y2: 154.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M518.17,143.3A16.42,16.42,0,0,0,525.54,157a16.44,16.44,0,0,0-.92-26.76A16.41,16.41,0,0,0,518.17,143.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 561.48,
    cy: 143.74,
    r: 17.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 561.48,
    cy: 143.74,
    r: 16.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 561.48,
    cy: 143.74,
    r: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 561.48,
    y1: 143.74,
    x2: 571.34,
    y2: 133.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M564.33,143.3A16.42,16.42,0,0,0,571.7,157a16.44,16.44,0,0,0-.92-26.76A16.41,16.41,0,0,0,564.33,143.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M11.51,108.32,9.24,106a.55.55,0,0,0-.39-.16H8.48a4.74,4.74,0,1,0-.82.82v.37a.55.55,0,0,0,.16.39l2.27,2.27a.54.54,0,0,0,.77,0l.64-.64A.55.55,0,0,0,11.51,108.32Zm-6.77-2.43A2.92,2.92,0,1,1,7.66,103,2.91,2.91,0,0,1,4.74,105.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M10.66,223.21H1a.27.27,0,0,1-.27-.27v-.82A1.09,1.09,0,0,1,1.82,221H2.92v-1.18a.27.27,0,0,1,.27-.27H4.1a.27.27,0,0,1,.27.27V221H7.29v-1.18a.27.27,0,0,1,.27-.27h.91a.27.27,0,0,1,.27.27V221H9.84a1.09,1.09,0,0,1,1.09,1.09v.82A.27.27,0,0,1,10.66,223.21ZM1,223.94h9.66a.27.27,0,0,1,.27.27v5.92a1.09,1.09,0,0,1-1.09,1.09h-8a1.09,1.09,0,0,1-1.09-1.09v-5.92A.27.27,0,0,1,1,223.94Zm7.59,2.19L8,225.48a.27.27,0,0,0-.39,0l-2.42,2.4-1-1.06a.27.27,0,0,0-.39,0l-.65.64a.27.27,0,0,0,0,.39L5,229.74a.27.27,0,0,0,.39,0l3.26-3.23a.27.27,0,0,0,0-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1.75,164.15A1.17,1.17,0,1,0,.58,163,1.17,1.17,0,0,0,1.75,164.15Zm8.17,0A1.17,1.17,0,1,0,8.75,163,1.17,1.17,0,0,0,9.92,164.15Zm.58.58H9.33a1.16,1.16,0,0,0-.82.34,2.67,2.67,0,0,1,1.37,2h1.2a.58.58,0,0,0,.58-.58v-.58A1.17,1.17,0,0,0,10.5,164.73Zm-4.67,0a2,2,0,1,0-2-2A2,2,0,0,0,5.83,164.73Zm1.4.58H7.08a2.82,2.82,0,0,1-2.5,0H4.43a2.1,2.1,0,0,0-2.1,2.1v.53a.88.88,0,0,0,.88.88H8.46a.88.88,0,0,0,.88-.88v-.53A2.1,2.1,0,0,0,7.23,165.31Zm-4.08-.24a1.16,1.16,0,0,0-.82-.34H1.17A1.17,1.17,0,0,0,0,165.9v.58a.58.58,0,0,0,.58.58h1.2a2.67,2.67,0,0,1,1.37-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3.4,194.15V196a.55.55,0,0,1-.55.55H.55A.55.55,0,0,1,0,196v-1.82a.55.55,0,0,1,.55-.55H2.86a.55.55,0,0,1,.55.55ZM0,197.8v1.82a.55.55,0,0,0,.55.55H2.86a.55.55,0,0,0,.55-.55V197.8a.55.55,0,0,0-.55-.55H.55A.55.55,0,0,0,0,197.8ZM2.86,190H.55a.55.55,0,0,0-.55.55v1.82a.55.55,0,0,0,.55.55H2.86a.55.55,0,0,0,.55-.55V190.5A.55.55,0,0,0,2.86,190Zm1.82,10.21h6.44a.55.55,0,0,0,.55-.55V197.8a.55.55,0,0,0-.55-.55H4.68a.55.55,0,0,0-.55.55v1.82a.55.55,0,0,0,.55.55Zm-.55-9.66v1.82a.55.55,0,0,0,.55.55h6.44a.55.55,0,0,0,.55-.55V190.5a.55.55,0,0,0-.55-.55H4.68a.55.55,0,0,0-.55.55Zm.55,6h6.44a.55.55,0,0,0,.55-.55v-1.82a.55.55,0,0,0-.55-.55H4.68a.55.55,0,0,0-.55.55V196a.55.55,0,0,0,.55.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M10.42,261.56H1.25A1.25,1.25,0,0,1,0,260.31v-9.17a1.25,1.25,0,0,1,1.25-1.25h9.17a1.25,1.25,0,0,1,1.25,1.25v9.17A1.25,1.25,0,0,1,10.42,261.56ZM5.09,259l4.79-4.79a.42.42,0,0,0,0-.59L9.29,253a.42.42,0,0,0-.59,0l-3.91,3.91L3,255.12a.42.42,0,0,0-.59,0l-.59.59a.42.42,0,0,0,0,.59L4.5,259a.42.42,0,0,0,.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M8.15,130.89,10,132.72a.2.2,0,0,1,0,.28l-4.42,4.42-1.88.21a.39.39,0,0,1-.44-.44l.21-1.88,4.42-4.42a.2.2,0,0,1,.28,0Zm3.28-.46-1-1a.79.79,0,0,0-1.12,0l-.72.72a.2.2,0,0,0,0,.28l1.83,1.83a.2.2,0,0,0,.28,0l.72-.72A.79.79,0,0,0,11.44,130.43Zm-3.66,5.79v2.06H1.3V131.8H6a.25.25,0,0,0,.17-.07l.81-.81a.24.24,0,0,0-.17-.42H1a1,1,0,0,0-1,1v7.13a1,1,0,0,0,1,1H8.1a1,1,0,0,0,1-1v-3.2a.24.24,0,0,0-.42-.17l-.81.81A.25.25,0,0,0,7.78,136.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M31.25,107.45a2.52,2.52,0,0,1-1,2.09,4.2,4.2,0,0,1-2.66.76,6.34,6.34,0,0,1-2.78-.53v-1.54a7.52,7.52,0,0,0,1.45.51,6.15,6.15,0,0,0,1.43.18,2.27,2.27,0,0,0,1.43-.37,1.2,1.2,0,0,0,.46-1,1.24,1.24,0,0,0-.42-1,6.38,6.38,0,0,0-1.75-.92,4.63,4.63,0,0,1-1.93-1.26,2.67,2.67,0,0,1-.56-1.71,2.39,2.39,0,0,1,.89-2,3.69,3.69,0,0,1,2.39-.72,7,7,0,0,1,2.86.63L30.58,102a6.25,6.25,0,0,0-2.38-.56,1.83,1.83,0,0,0-1.2.35,1.13,1.13,0,0,0-.41.91,1.28,1.28,0,0,0,.16.67,1.67,1.67,0,0,0,.54.52,9.16,9.16,0,0,0,1.35.65,7.42,7.42,0,0,1,1.61.85,2.51,2.51,0,0,1,.75.9A2.7,2.7,0,0,1,31.25,107.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M36.31,110.3a3.66,3.66,0,0,1-2.76-1,3.91,3.91,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91A3.19,3.19,0,0,1,36,102.47a3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.83,5.83,0,0,0,1.25-.13,6.54,6.54,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,36.31,110.3ZM36,103.68a1.61,1.61,0,0,0-1.23.49,2.31,2.31,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,36,103.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M42.69,110.16H41.08V99.53h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M48.28,110.3a3.65,3.65,0,0,1-2.76-1,3.9,3.9,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91A3.19,3.19,0,0,1,48,102.47a3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.81,5.81,0,0,0,1.25-.13,6.52,6.52,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,48.28,110.3ZM48,103.68a1.62,1.62,0,0,0-1.23.49,2.32,2.32,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,48,103.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M56.1,110.3a3.31,3.31,0,0,1-2.61-1,5.08,5.08,0,0,1,0-5.81,3.46,3.46,0,0,1,2.7-1,5.05,5.05,0,0,1,2.15.44l-.49,1.29a4.87,4.87,0,0,0-1.68-.4q-2,0-2,2.6a3.12,3.12,0,0,0,.49,1.91,1.69,1.69,0,0,0,1.43.64,4.11,4.11,0,0,0,2-.53v1.4a3.17,3.17,0,0,1-.92.36A5.53,5.53,0,0,1,56.1,110.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M62.8,109a3.91,3.91,0,0,0,1.18-.18V110a3.25,3.25,0,0,1-.69.19,4.76,4.76,0,0,1-.87.08q-2.28,0-2.28-2.41v-4.07h-1v-.71l1.11-.59.55-1.6h1v1.68H63.9v1.22H61.74v4a1.14,1.14,0,0,0,.29.86A1.06,1.06,0,0,0,62.8,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M75.91,103.19a2.91,2.91,0,0,1-1,2.4,4.52,4.52,0,0,1-2.92.83h-1v3.74H69.29v-10h2.88a4.36,4.36,0,0,1,2.81.77A2.75,2.75,0,0,1,75.91,103.19Zm-5,1.86h.87a3.11,3.11,0,0,0,1.85-.44,1.59,1.59,0,0,0,.59-1.37A1.55,1.55,0,0,0,73.7,102a2.6,2.6,0,0,0-1.64-.42H70.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M79.34,110.16H77.73V99.53h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M86.37,110.16,86,109.11H86a3.09,3.09,0,0,1-1.1.94,3.48,3.48,0,0,1-1.42.25,2.4,2.4,0,0,1-1.74-.6,2.25,2.25,0,0,1-.63-1.7,2,2,0,0,1,.87-1.76,5,5,0,0,1,2.65-.65l1.31,0v-.4a1.53,1.53,0,0,0-.34-1.08,1.38,1.38,0,0,0-1-.36,3.63,3.63,0,0,0-1.11.17,8.45,8.45,0,0,0-1,.4l-.52-1.15a5.61,5.61,0,0,1,1.35-.49,6.2,6.2,0,0,1,1.38-.17,3.27,3.27,0,0,1,2.18.63,2.46,2.46,0,0,1,.74,2v5.09ZM84,109.07a2,2,0,0,0,1.41-.49,1.77,1.77,0,0,0,.53-1.37v-.66l-1,0a3.32,3.32,0,0,0-1.65.38,1.15,1.15,0,0,0-.52,1,1,1,0,0,0,.3.78A1.29,1.29,0,0,0,84,109.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M88.61,102.6h1.75l1.54,4.29a8.12,8.12,0,0,1,.46,1.72h.05a7.2,7.2,0,0,1,.23-.91q.16-.54,1.74-5.1h1.74l-3.23,8.57a3.07,3.07,0,0,1-2.94,2.36,4.63,4.63,0,0,1-1-.12v-1.27a3.76,3.76,0,0,0,.83.08,1.69,1.69,0,0,0,1.63-1.35l.28-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M101.13,102.47a2.63,2.63,0,0,1,2.21,1,5.64,5.64,0,0,1,0,5.77,2.91,2.91,0,0,1-4.45,0h-.11l-.29.9h-1.2V99.53h1.61v2.53q0,.28,0,.83t0,.7h.07A2.55,2.55,0,0,1,101.13,102.47Zm-.42,1.31a1.63,1.63,0,0,0-1.4.57,3.32,3.32,0,0,0-.44,1.91v.11a3.53,3.53,0,0,0,.44,2,1.63,1.63,0,0,0,1.43.62,1.45,1.45,0,0,0,1.3-.68,3.6,3.6,0,0,0,.44-2Q102.47,103.78,100.71,103.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M112.69,106.37a4.12,4.12,0,0,1-1,2.89,3.4,3.4,0,0,1-2.65,1,3.62,3.62,0,0,1-1.87-.48,3.16,3.16,0,0,1-1.25-1.37,4.67,4.67,0,0,1-.44-2.08,4.1,4.1,0,0,1,.94-2.87,3.42,3.42,0,0,1,2.66-1,3.33,3.33,0,0,1,2.6,1.06A4.08,4.08,0,0,1,112.69,106.37Zm-5.5,0q0,2.62,1.93,2.62t1.91-2.62q0-2.59-1.93-2.59a1.65,1.65,0,0,0-1.47.67A3.41,3.41,0,0,0,107.19,106.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M121.24,106.37a4.12,4.12,0,0,1-1,2.89,3.4,3.4,0,0,1-2.65,1,3.62,3.62,0,0,1-1.87-.48,3.16,3.16,0,0,1-1.25-1.37,4.67,4.67,0,0,1-.44-2.08,4.1,4.1,0,0,1,.94-2.87,3.42,3.42,0,0,1,2.66-1,3.33,3.33,0,0,1,2.6,1.06A4.08,4.08,0,0,1,121.24,106.37Zm-5.5,0q0,2.62,1.93,2.62t1.91-2.62q0-2.59-1.93-2.59a1.64,1.64,0,0,0-1.47.67A3.4,3.4,0,0,0,115.74,106.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.64,106.17l.91-1.13,2.28-2.43h1.85l-3,3.25,3.23,4.31H128l-2.43-3.32-.88.72v2.59h-1.59V99.53h1.59v5.19l-.08,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M31.14,140.16H25.49v-10h5.65v1.38h-4v2.72h3.77v1.37H27.12v3.14h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M39.78,140.16H38.17v-4.65a2,2,0,0,0-.35-1.31,1.36,1.36,0,0,0-1.12-.43,1.78,1.78,0,0,0-1.49.6,3.32,3.32,0,0,0-.47,2v3.77H33.13V132.6h1.26l.23,1h.08a2.24,2.24,0,0,1,1-.83,3.25,3.25,0,0,1,1.39-.29q2.72,0,2.72,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M44.83,139a3.91,3.91,0,0,0,1.18-.18V140a3.25,3.25,0,0,1-.69.19,4.76,4.76,0,0,1-.87.08q-2.28,0-2.28-2.41v-4.07h-1v-.71l1.11-.59.55-1.6h1v1.68h2.15v1.22H43.78v4a1.14,1.14,0,0,0,.29.86A1.06,1.06,0,0,0,44.83,139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M50.82,140.3a3.66,3.66,0,0,1-2.76-1,3.91,3.91,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.83,5.83,0,0,0,1.25-.13,6.54,6.54,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,50.82,140.3Zm-.29-6.62a1.61,1.61,0,0,0-1.23.49,2.31,2.31,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,50.53,133.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M59.42,132.47a3.88,3.88,0,0,1,.8.07l-.16,1.5a3,3,0,0,0-.71-.08,2.06,2.06,0,0,0-1.56.63,2.27,2.27,0,0,0-.6,1.63v4H55.58V132.6h1.26l.21,1.33h.08a3,3,0,0,1,1-1.07A2.33,2.33,0,0,1,59.42,132.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M71.19,137.45a2.52,2.52,0,0,1-1,2.09,4.2,4.2,0,0,1-2.66.76,6.34,6.34,0,0,1-2.78-.53v-1.54a7.56,7.56,0,0,0,1.45.51,6.17,6.17,0,0,0,1.43.18,2.28,2.28,0,0,0,1.43-.37,1.21,1.21,0,0,0,.46-1,1.24,1.24,0,0,0-.42-1,6.38,6.38,0,0,0-1.75-.92,4.63,4.63,0,0,1-1.93-1.26,2.67,2.67,0,0,1-.56-1.71,2.39,2.39,0,0,1,.89-2,3.69,3.69,0,0,1,2.39-.72,7,7,0,0,1,2.86.63L70.52,132a6.25,6.25,0,0,0-2.38-.56,1.83,1.83,0,0,0-1.2.35,1.13,1.13,0,0,0-.41.91,1.28,1.28,0,0,0,.16.67,1.67,1.67,0,0,0,.54.52,9.16,9.16,0,0,0,1.35.65,7.42,7.42,0,0,1,1.61.85,2.51,2.51,0,0,1,.75.9A2.7,2.7,0,0,1,71.19,137.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M78.29,140.16l-.23-1H78a2.28,2.28,0,0,1-1,.83,3.19,3.19,0,0,1-1.41.3,2.77,2.77,0,0,1-2.05-.68,2.83,2.83,0,0,1-.68-2.07V132.6h1.62v4.66a2,2,0,0,0,.36,1.3A1.36,1.36,0,0,0,76,139a1.78,1.78,0,0,0,1.49-.6,3.34,3.34,0,0,0,.47-2V132.6h1.61v7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M88.21,140.16H86.6V135.5a2.11,2.11,0,0,0-.33-1.3,1.21,1.21,0,0,0-1-.43,1.57,1.57,0,0,0-1.36.6,3.55,3.55,0,0,0-.43,2v3.77H81.84V132.6H83.1l.23,1h.08a2.1,2.1,0,0,1,.91-.83,3,3,0,0,1,1.32-.29,2.3,2.3,0,0,1,2.31,1.19h.11a2.31,2.31,0,0,1,.94-.87,3,3,0,0,1,1.39-.31,2.54,2.54,0,0,1,2,.68,3,3,0,0,1,.62,2.08v4.93H91.38V135.5a2.09,2.09,0,0,0-.33-1.3,1.22,1.22,0,0,0-1-.43,1.59,1.59,0,0,0-1.37.58,3,3,0,0,0-.43,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M101.6,140.16H100V135.5a2.11,2.11,0,0,0-.33-1.3,1.21,1.21,0,0,0-1-.43,1.57,1.57,0,0,0-1.36.6,3.55,3.55,0,0,0-.43,2v3.77H95.23V132.6h1.26l.23,1h.08a2.1,2.1,0,0,1,.91-.83,3,3,0,0,1,1.32-.29,2.3,2.3,0,0,1,2.31,1.19h.11a2.31,2.31,0,0,1,.94-.87,3,3,0,0,1,1.39-.31,2.54,2.54,0,0,1,2,.68,3,3,0,0,1,.62,2.08v4.93h-1.61V135.5a2.09,2.09,0,0,0-.33-1.3,1.22,1.22,0,0,0-1-.43,1.59,1.59,0,0,0-1.37.58,3,3,0,0,0-.43,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M113.34,140.16l-.32-1.05H113a3.09,3.09,0,0,1-1.1.94,3.48,3.48,0,0,1-1.42.25,2.4,2.4,0,0,1-1.74-.6,2.25,2.25,0,0,1-.63-1.7,2,2,0,0,1,.87-1.76,5,5,0,0,1,2.65-.65l1.31,0v-.4a1.53,1.53,0,0,0-.34-1.08,1.38,1.38,0,0,0-1-.36,3.63,3.63,0,0,0-1.11.17,8.45,8.45,0,0,0-1,.4l-.52-1.15a5.61,5.61,0,0,1,1.35-.49,6.2,6.2,0,0,1,1.38-.17,3.27,3.27,0,0,1,2.18.63,2.46,2.46,0,0,1,.74,2v5.09Zm-2.39-1.09a2,2,0,0,0,1.41-.49,1.77,1.77,0,0,0,.53-1.37v-.66l-1,0a3.32,3.32,0,0,0-1.65.38,1.15,1.15,0,0,0-.52,1,1,1,0,0,0,.3.78A1.29,1.29,0,0,0,110.95,139.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M120.57,132.47a3.88,3.88,0,0,1,.8.07l-.16,1.5a3,3,0,0,0-.71-.08,2.06,2.06,0,0,0-1.56.63,2.27,2.27,0,0,0-.6,1.63v4h-1.61V132.6H118l.21,1.33h.08a3,3,0,0,1,1-1.07A2.34,2.34,0,0,1,120.57,132.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M121.62,132.6h1.75l1.54,4.29a8.12,8.12,0,0,1,.46,1.72h.05a7.2,7.2,0,0,1,.23-.91q.16-.54,1.74-5.1h1.74l-3.23,8.57a3.07,3.07,0,0,1-2.94,2.36,4.63,4.63,0,0,1-1-.12v-1.27a3.76,3.76,0,0,0,.83.08,1.69,1.69,0,0,0,1.63-1.35l.28-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M31.69,170.16l-1-2.78H26.87l-1,2.78H24.17l3.74-10h1.78l3.74,10ZM30.26,166l-.94-2.72q-.1-.27-.28-.86t-.25-.86a15.26,15.26,0,0,1-.54,1.84l-.9,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M39.65,168a2,2,0,0,1-.81,1.7,3.86,3.86,0,0,1-2.31.59,5.46,5.46,0,0,1-2.43-.46v-1.39a6,6,0,0,0,2.48.62q1.48,0,1.48-.9a.71.71,0,0,0-.16-.48,1.94,1.94,0,0,0-.54-.4,9.38,9.38,0,0,0-1-.46,4.85,4.85,0,0,1-1.77-1,1.88,1.88,0,0,1-.46-1.31,1.72,1.72,0,0,1,.78-1.51,3.71,3.71,0,0,1,2.13-.54,6,6,0,0,1,2.52.54L39,164.22a5.61,5.61,0,0,0-2.06-.51q-1.27,0-1.27.72a.73.73,0,0,0,.33.6,7.26,7.26,0,0,0,1.45.68,6.62,6.62,0,0,1,1.36.66,2,2,0,0,1,.63.69A2,2,0,0,1,39.65,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M46.47,168a2,2,0,0,1-.81,1.7,3.86,3.86,0,0,1-2.31.59,5.46,5.46,0,0,1-2.43-.46v-1.39a6,6,0,0,0,2.48.62q1.48,0,1.48-.9a.71.71,0,0,0-.16-.48,1.94,1.94,0,0,0-.54-.4,9.38,9.38,0,0,0-1-.46,4.83,4.83,0,0,1-1.77-1,1.87,1.87,0,0,1-.46-1.31,1.72,1.72,0,0,1,.78-1.51,3.72,3.72,0,0,1,2.13-.54,6,6,0,0,1,2.52.54l-.52,1.21a5.61,5.61,0,0,0-2.06-.51q-1.27,0-1.27.72a.73.73,0,0,0,.33.6,7.31,7.31,0,0,0,1.45.68,6.62,6.62,0,0,1,1.36.66,2,2,0,0,1,.63.69A2,2,0,0,1,46.47,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M48.11,160.6a.89.89,0,0,1,.24-.66.92.92,0,0,1,.67-.23.9.9,0,0,1,.66.23.89.89,0,0,1,.24.66.87.87,0,0,1-.24.65.89.89,0,0,1-.66.24.91.91,0,0,1-.67-.24A.87.87,0,0,1,48.11,160.6Zm1.7,9.56H48.2V162.6h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M58.49,162.6v.88l-1.29.24a2.09,2.09,0,0,1,.29.59,2.33,2.33,0,0,1,.12.74,2.26,2.26,0,0,1-.81,1.84,3.38,3.38,0,0,1-2.22.67,3.59,3.59,0,0,1-.66-.05.9.9,0,0,0-.52.75.42.42,0,0,0,.24.39,2.09,2.09,0,0,0,.89.13h1.32a2.93,2.93,0,0,1,1.9.53,1.88,1.88,0,0,1,.65,1.54,2.24,2.24,0,0,1-1.06,2,5.58,5.58,0,0,1-3.06.7,4.23,4.23,0,0,1-2.36-.55,1.77,1.77,0,0,1-.81-1.56,1.65,1.65,0,0,1,.44-1.17,2.36,2.36,0,0,1,1.23-.66,1.21,1.21,0,0,1-.53-.44,1.11,1.11,0,0,1-.21-.64,1.1,1.1,0,0,1,.24-.72,2.76,2.76,0,0,1,.71-.58,2.1,2.1,0,0,1-1-.82,2.42,2.42,0,0,1-.37-1.34,2.4,2.4,0,0,1,.78-1.91,3.26,3.26,0,0,1,2.21-.68,5.42,5.42,0,0,1,.67,0,4.29,4.29,0,0,1,.53.09Zm-5.94,8.74a.88.88,0,0,0,.47.8,2.57,2.57,0,0,0,1.32.28,4,4,0,0,0,2-.38,1.13,1.13,0,0,0,.64-1,.75.75,0,0,0-.35-.7,2.82,2.82,0,0,0-1.31-.21H54.05a1.71,1.71,0,0,0-1.1.32A1.07,1.07,0,0,0,52.55,171.34Zm.69-6.29a1.52,1.52,0,0,0,.37,1.09,1.38,1.38,0,0,0,1,.38Q56,166.53,56,165a1.69,1.69,0,0,0-.35-1.14,1.31,1.31,0,0,0-1-.4,1.36,1.36,0,0,0-1.06.4A1.67,1.67,0,0,0,53.24,165.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M66.54,170.16H64.93v-4.65a2,2,0,0,0-.35-1.31,1.36,1.36,0,0,0-1.12-.43,1.78,1.78,0,0,0-1.49.6,3.32,3.32,0,0,0-.47,2v3.77H59.89V162.6h1.26l.23,1h.08a2.24,2.24,0,0,1,1-.83,3.25,3.25,0,0,1,1.39-.29q2.72,0,2.72,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M74.22,166.17v4H72.59v-10h2.82a4.64,4.64,0,0,1,2.86.72,2.6,2.6,0,0,1,.93,2.19,2.73,2.73,0,0,1-1.94,2.66l2.82,4.42H78.23l-2.39-4Zm0-1.35h1.13a2.59,2.59,0,0,0,1.65-.42,1.54,1.54,0,0,0,.51-1.26,1.35,1.35,0,0,0-.55-1.22,3,3,0,0,0-1.67-.37H74.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M88.07,166.37a4.12,4.12,0,0,1-1,2.89,3.4,3.4,0,0,1-2.65,1,3.62,3.62,0,0,1-1.87-.48,3.16,3.16,0,0,1-1.25-1.37,4.67,4.67,0,0,1-.44-2.08,4.1,4.1,0,0,1,.94-2.87,3.42,3.42,0,0,1,2.66-1,3.33,3.33,0,0,1,2.6,1.06A4.08,4.08,0,0,1,88.07,166.37Zm-5.5,0q0,2.62,1.93,2.62t1.91-2.62q0-2.59-1.93-2.59a1.65,1.65,0,0,0-1.47.67A3.41,3.41,0,0,0,82.57,166.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M91.52,170.16H89.92V159.53h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M97.12,170.3a3.65,3.65,0,0,1-2.76-1,3.9,3.9,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87H95a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.81,5.81,0,0,0,1.25-.13,6.52,6.52,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,97.12,170.3Zm-.29-6.62a1.62,1.62,0,0,0-1.23.49,2.32,2.32,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,96.83,163.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M107,168a2,2,0,0,1-.81,1.7,3.86,3.86,0,0,1-2.31.59,5.46,5.46,0,0,1-2.43-.46v-1.39a6,6,0,0,0,2.48.62q1.48,0,1.48-.9a.71.71,0,0,0-.16-.48,1.94,1.94,0,0,0-.54-.4,9.38,9.38,0,0,0-1-.46,4.83,4.83,0,0,1-1.77-1,1.87,1.87,0,0,1-.46-1.31,1.72,1.72,0,0,1,.78-1.51,3.72,3.72,0,0,1,2.13-.54,6,6,0,0,1,2.52.54l-.52,1.21a5.61,5.61,0,0,0-2.06-.51q-1.27,0-1.27.72a.73.73,0,0,0,.33.6,7.31,7.31,0,0,0,1.45.68,6.62,6.62,0,0,1,1.36.66,2,2,0,0,1,.63.69A2,2,0,0,1,107,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M115.15,169a3.91,3.91,0,0,0,1.18-.18V170a3.23,3.23,0,0,1-.69.19,4.73,4.73,0,0,1-.87.08q-2.28,0-2.28-2.41v-4.07h-1v-.71l1.11-.59.55-1.6h1v1.68h2.15v1.22H114.1v4a1.13,1.13,0,0,0,.29.86A1.06,1.06,0,0,0,115.15,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.55,166.37a4.12,4.12,0,0,1-1,2.89,3.4,3.4,0,0,1-2.65,1,3.62,3.62,0,0,1-1.87-.48,3.16,3.16,0,0,1-1.25-1.37,4.67,4.67,0,0,1-.44-2.08,4.1,4.1,0,0,1,.94-2.87,3.42,3.42,0,0,1,2.66-1,3.33,3.33,0,0,1,2.6,1.06A4.08,4.08,0,0,1,124.55,166.37Zm-5.5,0Q119,169,121,169t1.91-2.62q0-2.59-1.93-2.59a1.65,1.65,0,0,0-1.47.67A3.41,3.41,0,0,0,119,166.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M133,164.73l2.37-4.56h1.78l-3.33,6.12v3.88H132.2v-3.82l-3.32-6.17h1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M145,166.37a4.12,4.12,0,0,1-1,2.89,3.4,3.4,0,0,1-2.65,1,3.62,3.62,0,0,1-1.87-.48,3.16,3.16,0,0,1-1.25-1.37,4.67,4.67,0,0,1-.44-2.08,4.1,4.1,0,0,1,.94-2.87,3.42,3.42,0,0,1,2.66-1,3.33,3.33,0,0,1,2.6,1.06A4.08,4.08,0,0,1,145,166.37Zm-5.5,0q0,2.62,1.93,2.62t1.91-2.62q0-2.59-1.93-2.59a1.64,1.64,0,0,0-1.47.67A3.4,3.4,0,0,0,139.52,166.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M152.2,170.16l-.23-1h-.08a2.28,2.28,0,0,1-1,.83,3.19,3.19,0,0,1-1.41.3,2.77,2.77,0,0,1-2.05-.68,2.83,2.83,0,0,1-.68-2.07V162.6h1.62v4.66a2,2,0,0,0,.36,1.3,1.36,1.36,0,0,0,1.11.43,1.78,1.78,0,0,0,1.49-.6,3.34,3.34,0,0,0,.47-2V162.6h1.61v7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M159.59,162.47a3.88,3.88,0,0,1,.8.07l-.16,1.5a3,3,0,0,0-.71-.08,2.06,2.06,0,0,0-1.56.63,2.27,2.27,0,0,0-.6,1.63v4h-1.61V162.6H157l.21,1.33h.08a3,3,0,0,1,1-1.07A2.34,2.34,0,0,1,159.59,162.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M169,170.16h-1.63v-8.59h-2.94v-1.4H172v1.4H169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M176.65,170.3a3.65,3.65,0,0,1-2.76-1,3.9,3.9,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.81,5.81,0,0,0,1.25-.13,6.52,6.52,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,176.65,170.3Zm-.29-6.62a1.62,1.62,0,0,0-1.23.49,2.32,2.32,0,0,0-.55,1.42H178a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,176.36,163.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M186.14,170.16l-.32-1.05h-.05a3.09,3.09,0,0,1-1.1.94,3.48,3.48,0,0,1-1.42.25,2.4,2.4,0,0,1-1.74-.6,2.25,2.25,0,0,1-.63-1.7,2,2,0,0,1,.87-1.76,5,5,0,0,1,2.65-.65l1.31,0v-.4a1.53,1.53,0,0,0-.34-1.08,1.38,1.38,0,0,0-1-.36,3.63,3.63,0,0,0-1.11.17,8.45,8.45,0,0,0-1,.4l-.52-1.15a5.61,5.61,0,0,1,1.35-.49,6.2,6.2,0,0,1,1.38-.17,3.27,3.27,0,0,1,2.18.63,2.46,2.46,0,0,1,.74,2v5.09Zm-2.39-1.09a2,2,0,0,0,1.41-.49,1.77,1.77,0,0,0,.53-1.37v-.66l-1,0a3.32,3.32,0,0,0-1.65.38,1.15,1.15,0,0,0-.52,1,1,1,0,0,0,.3.78A1.29,1.29,0,0,0,183.75,169.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M195.91,170.16h-1.61V165.5a2.11,2.11,0,0,0-.33-1.3,1.21,1.21,0,0,0-1-.43,1.57,1.57,0,0,0-1.36.6,3.55,3.55,0,0,0-.43,2v3.77h-1.61V162.6h1.26l.23,1h.08a2.1,2.1,0,0,1,.91-.83,3,3,0,0,1,1.32-.29,2.3,2.3,0,0,1,2.31,1.19h.11a2.31,2.31,0,0,1,.94-.87,3,3,0,0,1,1.39-.31,2.54,2.54,0,0,1,2,.68,3,3,0,0,1,.62,2.08v4.93h-1.61V165.5a2.09,2.09,0,0,0-.33-1.3,1.22,1.22,0,0,0-1-.43,1.59,1.59,0,0,0-1.37.58,3,3,0,0,0-.43,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M208,168a2,2,0,0,1-.81,1.7,3.86,3.86,0,0,1-2.31.59,5.46,5.46,0,0,1-2.43-.46v-1.39a6,6,0,0,0,2.48.62q1.48,0,1.48-.9a.71.71,0,0,0-.16-.48,1.94,1.94,0,0,0-.54-.4,9.38,9.38,0,0,0-1-.46,4.83,4.83,0,0,1-1.77-1,1.87,1.87,0,0,1-.46-1.31,1.72,1.72,0,0,1,.78-1.51,3.72,3.72,0,0,1,2.13-.54,6,6,0,0,1,2.52.54l-.52,1.21a5.61,5.61,0,0,0-2.06-.51q-1.27,0-1.27.72a.73.73,0,0,0,.33.6,7.31,7.31,0,0,0,1.45.68,6.62,6.62,0,0,1,1.36.66,2,2,0,0,1,.63.69A2,2,0,0,1,208,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M29.74,191.43a2.69,2.69,0,0,0-2.21,1,5.24,5.24,0,0,0,0,5.54,2.74,2.74,0,0,0,2.25.94,5.89,5.89,0,0,0,1.23-.13q.59-.13,1.24-.32v1.4a7.5,7.5,0,0,1-2.67.44A4.26,4.26,0,0,1,26.17,199a5.56,5.56,0,0,1-1.18-3.8,6.14,6.14,0,0,1,.57-2.73,4.07,4.07,0,0,1,1.65-1.79,5,5,0,0,1,2.54-.62,6.3,6.3,0,0,1,2.83.64L32,192a8.84,8.84,0,0,0-1.07-.42A3.87,3.87,0,0,0,29.74,191.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M40.89,196.37a4.12,4.12,0,0,1-1,2.89,3.4,3.4,0,0,1-2.65,1,3.62,3.62,0,0,1-1.87-.48,3.16,3.16,0,0,1-1.25-1.37,4.67,4.67,0,0,1-.44-2.08,4.1,4.1,0,0,1,.94-2.87,3.42,3.42,0,0,1,2.66-1,3.33,3.33,0,0,1,2.6,1.06A4.08,4.08,0,0,1,40.89,196.37Zm-5.5,0q0,2.62,1.93,2.62t1.91-2.62q0-2.59-1.93-2.59a1.64,1.64,0,0,0-1.47.67A3.4,3.4,0,0,0,35.39,196.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M49.39,200.16H47.78v-4.65a2,2,0,0,0-.35-1.31,1.36,1.36,0,0,0-1.12-.43,1.78,1.78,0,0,0-1.49.6,3.32,3.32,0,0,0-.47,2v3.77H42.74V192.6H44l.23,1h.08a2.24,2.24,0,0,1,1-.83,3.25,3.25,0,0,1,1.39-.29q2.72,0,2.72,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M55.42,193.82H53.58v6.34H52v-6.34H50.72v-.75l1.24-.49v-.49a2.75,2.75,0,0,1,.63-2,2.57,2.57,0,0,1,1.92-.65,5.13,5.13,0,0,1,1.67.28l-.42,1.22a3.71,3.71,0,0,0-1.13-.19.92.92,0,0,0-.8.34,1.7,1.7,0,0,0-.25,1v.49h1.85Zm1.19-3.22a.89.89,0,0,1,.24-.66.92.92,0,0,1,.67-.23.9.9,0,0,1,.66.23.89.89,0,0,1,.24.66.87.87,0,0,1-.24.65.89.89,0,0,1-.66.24.91.91,0,0,1-.67-.24A.87.87,0,0,1,56.61,190.6Zm1.7,9.56H56.71V192.6h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M67,192.6v.88l-1.29.24a2.09,2.09,0,0,1,.29.59,2.33,2.33,0,0,1,.12.74,2.26,2.26,0,0,1-.81,1.84,3.38,3.38,0,0,1-2.22.67,3.59,3.59,0,0,1-.66-.05.9.9,0,0,0-.52.75.42.42,0,0,0,.24.39,2.1,2.1,0,0,0,.89.13h1.32a2.93,2.93,0,0,1,1.9.53,1.88,1.88,0,0,1,.65,1.54,2.24,2.24,0,0,1-1.06,2,5.58,5.58,0,0,1-3.06.7,4.23,4.23,0,0,1-2.36-.55,1.77,1.77,0,0,1-.81-1.56,1.66,1.66,0,0,1,.44-1.17,2.37,2.37,0,0,1,1.23-.66,1.21,1.21,0,0,1-.53-.44,1.14,1.14,0,0,1,0-1.36,2.76,2.76,0,0,1,.71-.58,2.11,2.11,0,0,1-1-.82,2.43,2.43,0,0,1-.37-1.34,2.4,2.4,0,0,1,.78-1.91,3.26,3.26,0,0,1,2.21-.68,5.39,5.39,0,0,1,.67,0,4.28,4.28,0,0,1,.53.09Zm-5.94,8.74a.88.88,0,0,0,.47.8,2.58,2.58,0,0,0,1.32.28,4,4,0,0,0,2-.38,1.13,1.13,0,0,0,.64-1,.75.75,0,0,0-.35-.7,2.83,2.83,0,0,0-1.31-.21H62.56a1.71,1.71,0,0,0-1.1.32A1.06,1.06,0,0,0,61.06,201.34Zm.69-6.29a1.52,1.52,0,0,0,.37,1.09,1.38,1.38,0,0,0,1,.38q1.39,0,1.39-1.49a1.69,1.69,0,0,0-.34-1.14,1.31,1.31,0,0,0-1-.4,1.35,1.35,0,0,0-1.06.4A1.66,1.66,0,0,0,61.75,195.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M73.73,200.16l-.23-1h-.08a2.28,2.28,0,0,1-1,.83,3.19,3.19,0,0,1-1.41.3,2.77,2.77,0,0,1-2.05-.68,2.83,2.83,0,0,1-.68-2.07V192.6H70v4.66a2,2,0,0,0,.36,1.3,1.36,1.36,0,0,0,1.11.43,1.78,1.78,0,0,0,1.49-.6,3.34,3.34,0,0,0,.47-2V192.6H75v7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M81.12,192.47a3.88,3.88,0,0,1,.8.07l-.16,1.5a3,3,0,0,0-.71-.08,2.06,2.06,0,0,0-1.56.63,2.27,2.27,0,0,0-.6,1.63v4H77.29V192.6h1.26l.21,1.33h.08a3,3,0,0,1,1-1.07A2.34,2.34,0,0,1,81.12,192.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M86.63,200.3a3.66,3.66,0,0,1-2.76-1,3.91,3.91,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59A5.83,5.83,0,0,0,88,198.9a6.54,6.54,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,86.63,200.3Zm-.29-6.62a1.61,1.61,0,0,0-1.23.49,2.31,2.31,0,0,0-.55,1.42H88a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,86.33,193.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M101.4,200.16l-1-2.78H96.58l-1,2.78H93.88l3.74-10H99.4l3.74,10ZM100,196,99,193.26q-.1-.27-.28-.86t-.25-.86a15.26,15.26,0,0,1-.54,1.84l-.9,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M107.33,200.3a3.31,3.31,0,0,1-2.61-1,5.07,5.07,0,0,1,0-5.81,3.46,3.46,0,0,1,2.7-1,5.05,5.05,0,0,1,2.15.44l-.49,1.29a4.87,4.87,0,0,0-1.68-.4q-2,0-2,2.6a3.12,3.12,0,0,0,.49,1.91,1.69,1.69,0,0,0,1.43.64,4.11,4.11,0,0,0,2-.53v1.4a3.16,3.16,0,0,1-.92.36A5.52,5.52,0,0,1,107.33,200.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M114,199a3.91,3.91,0,0,0,1.18-.18V200a3.23,3.23,0,0,1-.69.19,4.73,4.73,0,0,1-.87.08q-2.28,0-2.28-2.41v-4.07h-1v-.71l1.11-.59.55-1.6h1v1.68h2.15v1.22H113v4a1.13,1.13,0,0,0,.29.86A1.06,1.06,0,0,0,114,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M116.62,190.6a.89.89,0,0,1,.24-.66.92.92,0,0,1,.67-.23.9.9,0,0,1,.66.23.89.89,0,0,1,.24.66.88.88,0,0,1-.24.65.89.89,0,0,1-.66.24.91.91,0,0,1-.67-.24A.88.88,0,0,1,116.62,190.6Zm1.7,9.56h-1.61V192.6h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M122.34,200.16l-2.87-7.56h1.7l1.54,4.4a8.69,8.69,0,0,1,.48,1.79h.05a12,12,0,0,1,.48-1.79l1.54-4.4H127l-2.88,7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M128,190.6a.89.89,0,0,1,.24-.66.92.92,0,0,1,.67-.23.9.9,0,0,1,.66.23.89.89,0,0,1,.24.66.87.87,0,0,1-.24.65.89.89,0,0,1-.66.24.91.91,0,0,1-.67-.24A.87.87,0,0,1,128,190.6Zm1.7,9.56h-1.61V192.6h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M134.83,199a3.91,3.91,0,0,0,1.18-.18V200a3.25,3.25,0,0,1-.69.19,4.76,4.76,0,0,1-.87.08q-2.28,0-2.28-2.41v-4.07h-1v-.71l1.11-.59.55-1.6h1v1.68h2.15v1.22h-2.15v4a1.14,1.14,0,0,0,.29.86A1.06,1.06,0,0,0,134.83,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M137.42,190.6a.89.89,0,0,1,.24-.66.92.92,0,0,1,.67-.23.9.9,0,0,1,.66.23.89.89,0,0,1,.24.66.87.87,0,0,1-.24.65.89.89,0,0,1-.66.24.91.91,0,0,1-.67-.24A.87.87,0,0,1,137.42,190.6Zm1.7,9.56h-1.61V192.6h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M144.73,200.3a3.65,3.65,0,0,1-2.76-1,3.9,3.9,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.81,5.81,0,0,0,1.25-.13,6.52,6.52,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,144.73,200.3Zm-.29-6.62a1.62,1.62,0,0,0-1.23.49,2.32,2.32,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,144.43,193.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M154.57,198a2,2,0,0,1-.81,1.7,3.86,3.86,0,0,1-2.31.59,5.46,5.46,0,0,1-2.43-.46v-1.39a6,6,0,0,0,2.48.62q1.48,0,1.48-.9a.71.71,0,0,0-.16-.48,1.94,1.94,0,0,0-.54-.4,9.38,9.38,0,0,0-1-.46,4.83,4.83,0,0,1-1.77-1,1.87,1.87,0,0,1-.46-1.31,1.72,1.72,0,0,1,.78-1.51,3.72,3.72,0,0,1,2.13-.54,6,6,0,0,1,2.52.54l-.52,1.21a5.61,5.61,0,0,0-2.06-.51q-1.27,0-1.27.72a.73.73,0,0,0,.33.6,7.31,7.31,0,0,0,1.45.68,6.62,6.62,0,0,1,1.36.66,2,2,0,0,1,.63.69A2,2,0,0,1,154.57,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M31.25,227.45a2.52,2.52,0,0,1-1,2.09,4.2,4.2,0,0,1-2.66.76,6.34,6.34,0,0,1-2.78-.53v-1.54a7.52,7.52,0,0,0,1.45.51,6.15,6.15,0,0,0,1.43.18,2.27,2.27,0,0,0,1.43-.37,1.2,1.2,0,0,0,.46-1,1.24,1.24,0,0,0-.42-1,6.38,6.38,0,0,0-1.75-.92,4.63,4.63,0,0,1-1.93-1.26,2.67,2.67,0,0,1-.56-1.71,2.39,2.39,0,0,1,.89-2,3.69,3.69,0,0,1,2.39-.72,7,7,0,0,1,2.86.63L30.58,222a6.25,6.25,0,0,0-2.38-.56,1.83,1.83,0,0,0-1.2.35,1.13,1.13,0,0,0-.41.91,1.28,1.28,0,0,0,.16.67,1.67,1.67,0,0,0,.54.52,9.16,9.16,0,0,0,1.35.65,7.42,7.42,0,0,1,1.61.85,2.51,2.51,0,0,1,.75.9A2.7,2.7,0,0,1,31.25,227.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M36.31,230.3a3.66,3.66,0,0,1-2.76-1,3.91,3.91,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91A3.19,3.19,0,0,1,36,222.47a3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.83,5.83,0,0,0,1.25-.13,6.54,6.54,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,36.31,230.3ZM36,223.68a1.61,1.61,0,0,0-1.23.49,2.31,2.31,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,36,223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M43.9,229a3.91,3.91,0,0,0,1.18-.18V230a3.23,3.23,0,0,1-.69.19,4.73,4.73,0,0,1-.87.08q-2.28,0-2.28-2.41v-4.07h-1v-.71l1.11-.59.55-1.6h1v1.68H45v1.22H42.84v4a1.13,1.13,0,0,0,.29.86A1.06,1.06,0,0,0,43.9,229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M53.84,230.16H52.21v-8.59H49.27v-1.4h7.51v1.4H53.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M58,220.6a.89.89,0,0,1,.24-.66.92.92,0,0,1,.67-.23.9.9,0,0,1,.66.23.89.89,0,0,1,.24.66.87.87,0,0,1-.24.65.89.89,0,0,1-.66.24.91.91,0,0,1-.67-.24A.87.87,0,0,1,58,220.6Zm1.7,9.56H58.14V222.6h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M68.42,230.16H66.8V225.5a2.11,2.11,0,0,0-.33-1.3,1.21,1.21,0,0,0-1-.43,1.57,1.57,0,0,0-1.36.6,3.55,3.55,0,0,0-.43,2v3.77H62V222.6H63.3l.23,1h.08a2.1,2.1,0,0,1,.91-.83,3,3,0,0,1,1.32-.29,2.3,2.3,0,0,1,2.31,1.19h.11a2.31,2.31,0,0,1,.94-.87,3,3,0,0,1,1.39-.31,2.54,2.54,0,0,1,2,.68,3,3,0,0,1,.62,2.08v4.93H71.58V225.5a2.09,2.09,0,0,0-.33-1.3,1.22,1.22,0,0,0-1-.43,1.59,1.59,0,0,0-1.37.58,3,3,0,0,0-.43,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M78.73,230.3a3.65,3.65,0,0,1-2.76-1,3.9,3.9,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.81,5.81,0,0,0,1.25-.13,6.52,6.52,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,78.73,230.3Zm-.29-6.62a1.62,1.62,0,0,0-1.23.49,2.32,2.32,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,78.44,223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M85.1,230.16H83.5V219.53H85.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M87.3,220.6a.89.89,0,0,1,.24-.66.92.92,0,0,1,.67-.23.9.9,0,0,1,.66.23.89.89,0,0,1,.24.66.87.87,0,0,1-.24.65.89.89,0,0,1-.66.24.91.91,0,0,1-.67-.24A.87.87,0,0,1,87.3,220.6Zm1.7,9.56H87.4V222.6H89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M98,230.16H96.34v-4.65a2,2,0,0,0-.35-1.31,1.36,1.36,0,0,0-1.12-.43,1.78,1.78,0,0,0-1.49.6,3.32,3.32,0,0,0-.47,2v3.77H91.3V222.6h1.26l.23,1h.08a2.24,2.24,0,0,1,1-.83,3.25,3.25,0,0,1,1.39-.29q2.72,0,2.72,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M103.49,230.3a3.65,3.65,0,0,1-2.76-1,3.9,3.9,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.81,5.81,0,0,0,1.25-.13,6.52,6.52,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,103.49,230.3Zm-.29-6.62a1.62,1.62,0,0,0-1.23.49,2.32,2.32,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,103.2,223.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M27.12,256.17v4H25.49v-10h2.82a4.64,4.64,0,0,1,2.86.72,2.6,2.6,0,0,1,.93,2.19,2.73,2.73,0,0,1-1.94,2.66L33,260.16H31.13l-2.39-4Zm0-1.35h1.13a2.59,2.59,0,0,0,1.65-.42,1.54,1.54,0,0,0,.51-1.26,1.35,1.35,0,0,0-.55-1.22,3,3,0,0,0-1.67-.37H27.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M37.57,260.3a3.65,3.65,0,0,1-2.76-1,3.9,3.9,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.81,5.81,0,0,0,1.25-.13,6.52,6.52,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,37.57,260.3Zm-.29-6.62a1.62,1.62,0,0,0-1.23.49,2.32,2.32,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,37.27,253.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M44.05,260.16l-2.87-7.56h1.7l1.54,4.4a8.69,8.69,0,0,1,.48,1.79h.05a12,12,0,0,1,.48-1.79L47,252.6h1.71l-2.88,7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M49.73,250.6a.89.89,0,0,1,.24-.66.92.92,0,0,1,.67-.23.9.9,0,0,1,.66.23.89.89,0,0,1,.24.66.88.88,0,0,1-.24.65.89.89,0,0,1-.66.24.91.91,0,0,1-.67-.24A.88.88,0,0,1,49.73,250.6Zm1.7,9.56H49.82V252.6h1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M57,260.3a3.66,3.66,0,0,1-2.76-1,3.91,3.91,0,0,1-1-2.83,4.29,4.29,0,0,1,.92-2.91,3.19,3.19,0,0,1,2.54-1.06,3.12,3.12,0,0,1,2.37.91,3.47,3.47,0,0,1,.87,2.5v.87h-5a2.48,2.48,0,0,0,.59,1.69,2.07,2.07,0,0,0,1.58.59,5.83,5.83,0,0,0,1.25-.13,6.54,6.54,0,0,0,1.24-.42v1.31a4.91,4.91,0,0,1-1.19.4A7.31,7.31,0,0,1,57,260.3Zm-.29-6.62a1.61,1.61,0,0,0-1.23.49,2.31,2.31,0,0,0-.55,1.42h3.43a2.09,2.09,0,0,0-.45-1.42A1.54,1.54,0,0,0,56.73,253.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M68,260.16l-1-3.53q-.18-.56-.64-2.6h-.06q-.4,1.85-.63,2.62l-1,3.51H62.9l-2.12-7.56h1.64l1,3.73q.33,1.38.46,2.37h0q.07-.5.21-1.15t.24-1l1.15-4h1.76l1.11,4q.1.34.26,1a7.81,7.81,0,0,1,.18,1.07h.05a20.91,20.91,0,0,1,.48-2.35l1-3.73h1.61l-2.13,7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M76.37,257.52a2.78,2.78,0,0,1,.44-1.56,4.6,4.6,0,0,1,1.58-1.32,5.77,5.77,0,0,1-.88-1.28,2.59,2.59,0,0,1-.24-1.08,2,2,0,0,1,.74-1.64,3.07,3.07,0,0,1,2-.6,2.85,2.85,0,0,1,1.9.58,2,2,0,0,1,.69,1.58,2.35,2.35,0,0,1-.46,1.42,5,5,0,0,1-1.54,1.27L83,257.16a6.18,6.18,0,0,0,.92-2.15h1.65A7.53,7.53,0,0,1,84,258.17l2.06,2H84l-1-1a4.92,4.92,0,0,1-3.23,1.13,3.74,3.74,0,0,1-2.47-.75A2.51,2.51,0,0,1,76.37,257.52Zm3.45,1.4a3.26,3.26,0,0,0,2.14-.73l-2.62-2.58a3.44,3.44,0,0,0-1,.87,1.62,1.62,0,0,0-.27.93,1.39,1.39,0,0,0,.48,1.09A1.85,1.85,0,0,0,79.82,258.92Zm-1-6.6a1.56,1.56,0,0,0,.23.81,4.76,4.76,0,0,0,.64.81,3.91,3.91,0,0,0,1.08-.82,1.31,1.31,0,0,0,.31-.85.91.91,0,0,0-.3-.71,1.14,1.14,0,0,0-.79-.27,1.26,1.26,0,0,0-.86.28A.93.93,0,0,0,78.8,252.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M96.8,257.45a2.52,2.52,0,0,1-1,2.09,4.2,4.2,0,0,1-2.66.76,6.34,6.34,0,0,1-2.78-.53v-1.54a7.56,7.56,0,0,0,1.45.51,6.17,6.17,0,0,0,1.43.18,2.28,2.28,0,0,0,1.43-.37,1.21,1.21,0,0,0,.46-1,1.24,1.24,0,0,0-.42-1,6.38,6.38,0,0,0-1.75-.92,4.63,4.63,0,0,1-1.93-1.26,2.67,2.67,0,0,1-.56-1.71,2.39,2.39,0,0,1,.89-2,3.69,3.69,0,0,1,2.39-.72,7,7,0,0,1,2.86.63L96.13,252a6.25,6.25,0,0,0-2.38-.56,1.83,1.83,0,0,0-1.2.35,1.13,1.13,0,0,0-.41.91,1.28,1.28,0,0,0,.16.67,1.67,1.67,0,0,0,.54.52,9.16,9.16,0,0,0,1.35.65,7.42,7.42,0,0,1,1.61.85,2.51,2.51,0,0,1,.75.9A2.7,2.7,0,0,1,96.8,257.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M101.38,259a3.91,3.91,0,0,0,1.18-.18V260a3.25,3.25,0,0,1-.69.19,4.76,4.76,0,0,1-.87.08q-2.28,0-2.28-2.41v-4.07h-1v-.71l1.11-.59.55-1.6h1v1.68h2.15v1.22h-2.15v4a1.14,1.14,0,0,0,.29.86A1.06,1.06,0,0,0,101.38,259Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M108.8,260.16l-.32-1.05h-.05a3.09,3.09,0,0,1-1.1.94,3.48,3.48,0,0,1-1.42.25,2.41,2.41,0,0,1-1.74-.6,2.25,2.25,0,0,1-.62-1.7,2,2,0,0,1,.87-1.76,5,5,0,0,1,2.65-.65l1.31,0v-.4a1.52,1.52,0,0,0-.34-1.08,1.38,1.38,0,0,0-1-.36,3.63,3.63,0,0,0-1.11.17,8.45,8.45,0,0,0-1,.4l-.52-1.15a5.61,5.61,0,0,1,1.35-.49,6.2,6.2,0,0,1,1.38-.17,3.27,3.27,0,0,1,2.18.63,2.46,2.46,0,0,1,.73,2v5.09Zm-2.39-1.09a2,2,0,0,0,1.4-.49,1.77,1.77,0,0,0,.53-1.37v-.66l-1,0a3.32,3.32,0,0,0-1.65.38,1.15,1.15,0,0,0-.52,1,1,1,0,0,0,.3.78A1.29,1.29,0,0,0,106.4,259.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M116,252.47a3.88,3.88,0,0,1,.8.07l-.16,1.5a3,3,0,0,0-.71-.08,2.06,2.06,0,0,0-1.56.63,2.27,2.27,0,0,0-.6,1.63v4h-1.61V252.6h1.26l.21,1.33h.08a3,3,0,0,1,1-1.07A2.33,2.33,0,0,1,116,252.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M121,259a3.91,3.91,0,0,0,1.18-.18V260a3.25,3.25,0,0,1-.69.19,4.76,4.76,0,0,1-.87.08q-2.28,0-2.28-2.41v-4.07h-1v-.71l1.11-.59.55-1.6h1v1.68h2.15v1.22H120v4a1.14,1.14,0,0,0,.29.86A1.06,1.06,0,0,0,121,259Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInitiativesGraphics);
export default __webpack_public_path__ + "static/media/No-Initiatives-Graphics.9b00c0eb6f788b13f4e62dd689efed8c.svg";
export { ForwardRef as ReactComponent };